// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.KGf1W{display:flex;gap:16px;align-items:center;padding-bottom:4px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"recipientDetails": `KGf1W`
};
export default ___CSS_LOADER_EXPORT___;
